import {SbBlokData, storyblokEditable} from "@storyblok/react";
import ButtonGroup from "../partials/ButtonGroup";
import LinePattern from "../partials/LinePattern";

interface IProps {
    blok: { title: string, subtitle: string, size: string, container_class: string, buttons: Array<any> } & SbBlokData
}

export default function SimpleHeader(props: IProps) {
    const buttons = <ButtonGroup buttons={props.blok.buttons ?? []}/>


    return (
        <div className={'relative bg-white ' + (props.blok.container_class || 'padding-lg')}>

            <svg id='patternId'
                 className={'w-1/4 absolute right-0 top-0 aspect-[1/2] opacity-20'}
                 width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'>
                <defs>
                    <pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40'
                             patternTransform='scale(1) rotate(0)'>
                        <rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/>
                        <path d='M20-5V5m0 30v10m20-30v10M0 15v10' strokeLinecap='square' strokeWidth='1'
                              stroke='hsla(78, 59%, 55%, 1)' fill='none'/>
                        <path d='M-5 40H5M-5 0H5m30 0h10M35 40h10M15 20h10' strokeLinecap='square' strokeWidth='1'
                              stroke='hsla(231, 15%, 24%, 1)' fill='none'/>
                    </pattern>
                </defs>
                <rect width='800%' height='800%' transform='translate(0,0)' fill='url(#a)'/>
            </svg>

            <div

                className="relative px-6 lg:px-8"  {...storyblokEditable(props.blok)}>

                <div className="mx-auto max-w-2xl text-center"
                     data-aos={'fade-in'}
                >
                    <p className={(props.blok.size || 'text-4xl sm:text-4xl') + " font-bold tracking-tight text-gray-900"}>
                        {props.blok.title}
                    </p>
                    <p className="mt-6 text-lg leading-8 text-gray-600">
                        {props.blok.subtitle}
                    </p>

                    {buttons}
                </div>

            </div>
        </div>
    )

}